module.exports = __webpack_public_path__ + "static/img/contract.220beb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/contract.svg
// module id = avVb
// module chunks = 1